import { createClient } from '@supabase/supabase-js'

// Using the provided credentials directly to ensure zero configuration errors
const SUPABASE_URL = 'https://chmddtoxijshqzdfvasj.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNobWRkdG94aWpzaHF6ZGZ2YXNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg2OTYwNDQsImV4cCI6MjA4NDI3MjA0NH0.hsle__JWT1JCbaqP_Fjnua8pDnhK5vIR9ho97h1WJYE'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Supabase credentials missing!')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})